// 统一时间与评分格式化：后端返回 ISO UTC 字符串，直显会比北京时间少 8 小时，一律转本地时区

const pad = (n: number) => String(n).padStart(2, '0');

export const fmtTime = (v?: string | null, withSeconds = false): string => {
  if (!v) return '-';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '-';
  const date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  const hm = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return withSeconds ? `${date} ${hm}:${pad(d.getSeconds())}` : `${date} ${hm}`;
};

// 仅时分（今日列表等场景）
export const fmtHM = (v?: string | null): string => {
  if (!v) return '-';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '-';
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// 金额展示：后端 Decimal 序列化成字符串（如 "12"、"12.5"），裸渲染会少位小数，统一补两位
export const fmtMoney = (v?: string | number | null): string => {
  const n = Number(v);
  return `¥${(Number.isFinite(n) ? n : 0).toFixed(2)}`;
};

// 评分星条：越界值（如投诉携带 rating=999）如实展示，避免 repeat 抛 RangeError 整页白屏
export const stars = (v?: number | null): string => {
  if (!v) return '-';
  const n = Math.round(v);
  if (n < 1 || n > 5) return `异常评分(${v})`;
  return '★'.repeat(n) + '☆'.repeat(5 - n);
};
